import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ToggleButton from "./ToggleButton";
import NumberInput from "./NumberInput";

interface Props {
    name: string;
    icon: React.ReactNode;
    allow: boolean;
    setAllow: (val: boolean) => void;
    hours: number;
    setHours: (val: number) => void;
    prefix?: string;
    nextRef?: React.RefObject<HTMLInputElement>;
    disabled?: boolean;
}

const HoursBlock = React.forwardRef((props: Props, ref) => {
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    const { name, icon, allow, setAllow, hours, setHours, prefix, nextRef, disabled } = props;

    return (
        <Stack spacing={1.5}>
            {/* Label + toggle row */}
            <Stack direction="row" alignItems="center" spacing={1}>
                <Box
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "10px",
                        bgcolor: alpha(primary, 0.1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: "0 0 auto",
                    }}
                >
                    {icon}
                </Box>
                <Typography
                    fontWeight={400}
                    fontSize="12px"
                    lineHeight="18px"
                    color="text.secondary"
                    flex={1}
                >
                    {name}
                </Typography>
                <ToggleButton value={allow} onClick={setAllow} />
            </Stack>

            {/* Hours input row */}
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                pl={5.5}
                sx={{
                    opacity: allow ? 1 : 0.35,
                    transition: "opacity 0.2s ease",
                }}
            >
                {prefix && (
                    <Typography fontWeight={400} fontSize="12px" lineHeight="18px">
                        {prefix}
                    </Typography>
                )}
                <NumberInput
                    ref={ref}
                    value={hours}
                    onChange={setHours}
                    minValue={1}
                    maxLength={2}
                    selectValueOnFocus
                    variant="underlined"
                    width={60}
                    disabled={!allow || disabled}
                    sx={{
                        fontWeight: 700,
                        fontSize: "18px",
                        lineHeight: "22px",
                        textAlign: "center",
                        color: primary,
                    }}
                    nextRef={nextRef}
                />
                <Typography
                    fontWeight={600}
                    fontSize="13px"
                    lineHeight="18px"
                    color={primary}
                >
                    hours
                </Typography>
            </Stack>
        </Stack>
    );
});

export default HoursBlock;
